(function () {
  if (window.__noorPickerInit) return;
  window.__noorPickerInit = true;

  function getMatrix(root) {
    var el = root.querySelector('.noorVariantMatrix');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function findVariant(matrix, sel) {
    for (var i = 0; i < matrix.length; i++) {
      var v = matrix[i];
      if (
        (sel.opt1 == null || v.opt1 === sel.opt1) &&
        (sel.opt2 == null || v.opt2 === sel.opt2) &&
        (sel.opt3 == null || v.opt3 === sel.opt3)
      ) {
        return v;
      }
    }
    return null;
  }

  function currentSelection(root) {
    var sel = { opt1: null, opt2: null, opt3: null };
    root.querySelectorAll('.noorCard-optGroup').forEach(function (g) {
      var pos = parseInt(g.getAttribute('data-option-position'), 10);
      var active = g.querySelector('.is-active');
      var val = active ? active.getAttribute('data-value') : null;
      if (pos === 1) sel.opt1 = val;
      if (pos === 2) sel.opt2 = val;
      if (pos === 3) sel.opt3 = val;
    });
    return sel;
  }

  function withOverride(sel, pos, val) {
    var next = { opt1: sel.opt1, opt2: sel.opt2, opt3: sel.opt3 };
    if (pos === 1) next.opt1 = val;
    if (pos === 2) next.opt2 = val;
    if (pos === 3) next.opt3 = val;
    return next;
  }

  function updateCard(root) {
    var matrix = getMatrix(root);
    if (!matrix.length) return;

    var sel = currentSelection(root);

    // Update purchase-type / price pills with live prices for the current combo
    var priceGroup = root.querySelector('.noorCard-purchaseType');
    if (priceGroup) {
      var pricePos = parseInt(priceGroup.getAttribute('data-option-position'), 10);
      priceGroup.querySelectorAll('.noorPricePill').forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var variant = findVariant(matrix, withOverride(sel, pricePos, val));
        var priceEl = btn.querySelector('[data-variant-price]');
        if (variant && priceEl) priceEl.textContent = variant.price;
        btn.classList.toggle('is-disabled', !!variant && !variant.available);
      });
    }

    // Disable unavailable values in the other option groups
    root.querySelectorAll('.noorCard-optGroup').forEach(function (g) {
      if (g === priceGroup) return;
      var pos = parseInt(g.getAttribute('data-option-position'), 10);
      g.querySelectorAll('.noorPill').forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var variant = findVariant(matrix, withOverride(sel, pos, val));
        btn.classList.toggle('is-unavailable', !(variant && variant.available));
      });
    });

    var finalVariant = findVariant(matrix, sel);
    var select = root.querySelector('.noorHiddenSelect');
    var addBtn = root.closest('.noorForm') ? root.closest('.noorForm').querySelector('.noorAddBtn') : root.parentElement.querySelector('.noorAddBtn');

    if (finalVariant && select) {
      if (String(select.value) !== String(finalVariant.id)) {
        select.value = finalVariant.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (addBtn) addBtn.disabled = !finalVariant || !finalVariant.available;
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.noorPill, .noorPricePill');
    if (!pill || pill.classList.contains('is-unavailable') || pill.classList.contains('is-disabled')) return;
    var group = pill.closest('.noorCard-optGroup');
    var root = pill.closest('[data-noor-picker]');
    if (!group || !root) return;
    e.preventDefault();
    group.querySelectorAll('.noorPill, .noorPricePill').forEach(function (b) {
      b.classList.remove('is-active');
    });
    pill.classList.add('is-active');
    updateCard(root);
  });

  function initAll() {
    document.querySelectorAll('[data-noor-picker]').forEach(updateCard);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
